import React from "react";
import { Link } from "react-router-dom";
import { getAuthorProfile } from "@/data/authors";

export interface AuthorBioProps {
  author?: string | null;
  className?: string;
}

const AuthorBio = ({ author, className = "" }: AuthorBioProps) => {
  const profile = getAuthorProfile(author);

  return (
    <section
      className={`rounded-2xl bg-elfGreen-light p-6 md:p-8 ${className}`.trim()}
      aria-labelledby="author-bio-heading"
    >
      <h2 id="author-bio-heading" className="text-2xl font-bold mb-3 text-elfGreen-ink">
        About {profile.displayName}
      </h2>

      {profile.kind === "founder" && (
        <>
          <p className="mb-3">
            Donnie is the founder of Elf Letter Bot and The Magic Letter Box.
          </p>
          <p className="mb-4">
            Letters here are AI-assisted starting points. A parent or caregiver reviews the details before sharing them with a child.
          </p>
          <Link to="/about#donnie" className="font-semibold text-elfGreen-ink hover:underline">
            Read Donnie&apos;s founder note
          </Link>
        </>
      )}

      {profile.kind === "editorial" && (
        <>
          <p className="mb-3">
            Elf Letter Team is the editorial contributor label for resources published without a named individual byline.
          </p>
          <p className="mb-4">
            Named contributors keep the credit shown on their articles. Review ideas and AI-assisted letters for your own family before sharing them.
          </p>
          <Link to="/about#editorial" className="font-semibold text-elfGreen-ink hover:underline">
            Read our editorial notes
          </Link>
        </>
      )}

      {profile.kind === "unknown" && (
        <>
          <p className="mb-3">
            This post credits {profile.displayName} as its author.
          </p>
          <p className="mb-4">
            For publisher information and our approach to AI-assisted letters, see the Elf Letter Bot editorial notes.
          </p>
          <Link to="/about#editorial" className="font-semibold text-elfGreen-ink hover:underline">
            Read our editorial notes
          </Link>
        </>
      )}
    </section>
  );
};

export default AuthorBio;
